/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	submitRegisterPaymentMethod,
	submitGetPaymentMethods,
	submitGetDefaultPaymentMethod,
	submitUpdatePaymentMethod,
} from "../services/paymentMethodService";

export interface IRegisterPaymentMethodPayload {
	paymentMethodId: string;
	billingName?: string;
	postalCode?: string;
}

/**
 * Register a new payment method (card) for the user
 */
export const registerPaymentMethod = createAsyncThunk(
	"paymentMethod/register",
	async (payload: IRegisterPaymentMethodPayload, { rejectWithValue }) => {
		try {
			const response = await submitRegisterPaymentMethod(payload);
			return response;
		} catch (error: any) {
			return rejectWithValue(
				error.response?.data?.message ||
					error.message ||
					"Failed to register payment method",
			);
		}
	},
);

export const updatePaymentMethod = createAsyncThunk(
	"paymentMethod/update",
	async (payload: IRegisterPaymentMethodPayload, { rejectWithValue }) => {
		try {
			const response = await submitUpdatePaymentMethod(payload);
			return response;
		} catch (error: any) {
			return rejectWithValue(
				error.response?.data?.message ||
					error.message ||
					"Failed to update payment method",
			);
		}
	},
);

/**
 * Get all payment methods for the authenticated user
 */
export const getPaymentMethods = createAsyncThunk(
	"paymentMethod/getAll",
	async (_, { rejectWithValue }) => {
		try {
			const response = await submitGetPaymentMethods();
			return response;
		} catch (error: any) {
			return rejectWithValue(
				error.response?.data?.message ||
					error.message ||
					"Failed to retrieve payment methods",
			);
		}
	},
);

/**
 * Get default payment method for the authenticated user
 */
export const getDefaultPaymentMethod = createAsyncThunk(
	"paymentMethod/getDefault",
	async (_, { rejectWithValue }) => {
		try {
			const response = await submitGetDefaultPaymentMethod();
			return response;
		} catch (error: any) {
			return rejectWithValue(
				error.response?.data?.message ||
					error.message ||
					"Failed to retrieve default payment method",
			);
		}
	},
);
